import { render, staticRenderFns } from "./CompactThumb.vue?vue&type=template&id=6156888a&scoped=true"
import script from "./CompactThumb.vue?vue&type=script&lang=js"
export * from "./CompactThumb.vue?vue&type=script&lang=js"
import style0 from "./CompactThumb.vue?vue&type=style&index=0&id=6156888a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6156888a",
  null
  
)

export default component.exports